import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const AdminsRoutes: Routes = [
  {
    path: "admins",
    loadComponent: () =>
      import("./admins/admins.component").then((m) => m.AdminsComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./admins-list/admins-list.component").then(
            (m) => m.AdminsListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./admin-form/admin-form.component").then(
            (m) => m.AdminFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./admin-form/admin-form.component").then(
            (m) => m.AdminFormComponent,
          ),
      },
    ],
  },
];
